import styled from "styled-components";

export default styled.span`
  margin-left: 5px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-weight: normal;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  text-transform: lowercase;
`;
